import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const TopSection = ({ screen, project, projectConfig, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Heading'>
        <Textfield
          placeholder='Heading'
          name='heading'
          value={content.heading || ''}
          onChange={onChange('heading')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Sub-heading'>
        <Textfield
          placeholder='Sub-heading'
          name='subHeading'
          value={content.subHeading || ''}
          onChange={onChange('subHeading')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Banner Text Position'>
        <Select
          aria-label='Banner Text Position'
          options={projectConfig.bannerPositionOptions}
          placeholder={'Select an option'}
          name='bannerTextPosition'
          value={content.bannerTextPosition || projectConfig.bannerPositionOptions[0].value}
          onChange={onChange('bannerTextPosition')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Image' labelFor='image'>
        <Switch
          label='Full width'
          checked={!!content.isFullWidthBanner}
          onChange={(v) => !disabled && onChange('isFullWidthBanner')(v)}
        />
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`accounts-dashboard-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Right Banner' labelFor='rightBannerImage'>
        <MediaUpload
          type='image'
          value={content.rightBannerImage || ''}
          maxHeight='100px'
          onUpload={onChange('rightBannerImage')}
          projectId={project?.meta?.id}
          path={`accounts-dashboard-${screen?.meta?.name}-right-banner`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Left Block'>
        <RichTextFormField
          label={'Left Block'}
          value={content.leftBlockRichText || ''}
          onChange={onChange('leftBlockRichText')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Left Button Label'>
        <Textfield
          placeholder='Button Label'
          name='leftButtonText'
          value={content.leftButtonText || ''}
          onChange={onChange('leftButtonText')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Right Button Label'>
        <Textfield
          placeholder='Button Label'
          name='rightButtonText'
          value={content.rightButtonText || ''}
          onChange={onChange('rightButtonText')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Right Image Text'>
        <Textfield
          placeholder='Right Image Text'
          name='rightTextOnImage'
          value={content.rightTextOnImage || ''}
          onChange={onChange('rightTextOnImage')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='List Headline' labelFor='listHeadline'>
        <Textfield
          placeholder='List Headline'
          name='listHeadline'
          value={content.listHeadline || ''}
          onChange={onChange('listHeadline')}
          disabled={disabled}
        />
      </FieldLabel>

      <ScreenPicker
        screenName={screen?.meta?.name}
        screens={content.list}
        onChange={onChange('list')}
        disabled={disabled}
        multiple
      />
    </>
  )
}

const BottomSection = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Title'>
        <Textfield
          placeholder='Title'
          name='contentRichTextTitle'
          value={content.contentRichTextTitle || ''}
          onChange={onChange('contentRichTextTitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Content'>
        <RichTextFormField
          label={'Content'}
          value={content.contentRichText || ''}
          onChange={onChange('contentRichText')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [
  { label: 'Top Section', content: TopSection },
  { label: 'Child Screens', content: ChildScreens },
  { label: 'Bottom Section', content: BottomSection },
]
